import { type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'

type Props = {
  children: ReactNode
}

export function ProtectedRoute({ children }: Props) {
  const token = useAuthStore((s) => s.token)
  const status = useAuthStore((s) => s.status)
  const location = useLocation()

  if (status === 'hydrating') {
    return (
      <div className="flex h-screen items-center justify-center text-gray-500">
        Authenticating…
      </div>
    )
  }

  if (!token) {
    // Preserve the full URL so deep links resume after sign-in. Login reads
    // `from` as a string and passes it straight to navigate().
    const fullPath = `${location.pathname}${location.search}${location.hash}`
    return <Navigate to="/login" replace state={{ from: fullPath }} />
  }

  return <>{children}</>
}
